var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJoinComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 99,
    viewBox: "0 0 78 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_491_7445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3198 17.6429V5.05404C46.1714 3.7027 46.6759 1 49.8812 1C53.8879 1 59.6752 5.69416 59.6752 9.96157C59.6752 13.3755 59.6752 21.6258 59.6752 25.3243",
    stroke: "url(#paint0_linear_491_7445)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8296 15.0066L6.88532 20.412L4.97754 66.5168L31.0506 59.2036V4.1958L21.8296 15.0066Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0505 59.2036V4.1958L71.114 29.315L70.4781 73.194L31.0505 59.2036Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9028 43.9415L6.88542 20.4121L4.65967 66.5169L47.9028 91.0002V43.9415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9033 90.9998V43.9411L55.2165 35.0381L61.5758 84.3225L47.9033 90.9998Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3403 78.5995L61.5756 84.3228L55.2163 35.0384L70.7966 28.9971L73.3403 78.5995Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5634 37.1024V24.5135C19.415 23.1622 19.9196 20.4595 23.1249 20.4595C27.1315 20.4595 32.9189 25.1536 32.9189 29.421C32.9189 32.835 32.9189 41.0853 32.9189 44.7837",
    stroke: "url(#paint1_linear_491_7445)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_491_7445",
    x: 0.659668,
    y: 0,
    width: 76.6807,
    height: 99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_7445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_7445",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_7445",
    x1: 52.986,
    y1: 1,
    x2: 52.986,
    y2: 25.3243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F23F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A148D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_491_7445",
    x1: 26.2297,
    y1: 20.4595,
    x2: 26.2297,
    y2: 44.7837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F23F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A148D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJoinComplete);
export default __webpack_public_path__ + "static/media/icon_join_complete.856392d2a462efd874c64b842c2a5d0c.svg";
export { ForwardRef as ReactComponent };